/**
 * Markets View Input text / Suspend Limit Save — local apply after marketUpdateOne.
 * Do not reload getone afterward; empty string must stick over a stale banner.
 */
export function applyMarketTextSave<T extends { marketInputText: string; bookmakerLimit: number | string }>(
  market: T | null | undefined,
  saved: { marketInputText: string; bookmakerLimit: number | string },
): T | null {
  if (!market) return null
  return {
    ...market,
    marketInputText: String(saved.marketInputText ?? ''),
    bookmakerLimit: saved.bookmakerLimit,
  }
}
